import { Menu } from '@/components/layout/menu';
import { SidebarToggle } from '@/components/layout/sidebar-toggle';
import { Button } from '@/components/ui/button';
import { useMainContext } from '@/context/main-context';
import { cn } from '@/lib/utils';
import React from 'react';
import { Link } from 'react-router-dom';
import AddBranchDialog from '../dialogs/branches/add-new-branch';

export function Sidebar() {
  const { isOpen, setIsOpen } = useMainContext();
  const [openAddBranchDialog, setOpenAddBranchDialog] = React.useState(false);

  // https://simplicity.framer.media/?via=hxmzaehsan
  // https://scalable.framer.website/?via=hxmzaehsan

  return (
    <aside
      className={cn(
        'fixed top-0 left-0 z-20 border-r -translate-x-full lg:translate-x-0 transition-[width] ease-in-out duration-300 bg-muted dark:bg-background',
        isOpen === false ? 'w-[90px]' : 'w-72'
      )}
    >
      <AddBranchDialog
        open={openAddBranchDialog}
        setOpen={setOpenAddBranchDialog}
      />
      <SidebarToggle isOpen={isOpen} setIsOpen={setIsOpen} />
      <div className="relative h-screen flex flex-col px-3 py-4 overflow-y-auto dark:shadow-zinc-800">
        {isOpen === false ? (
          <Button variant="link" asChild>
            <Link to="/">
              <img
                className="w-16 lg:w-20 block dark:hidden"
                src="/assets/logos/studypro-shape-black.svg"
                alt="Light mode logo"
              />
              <img
                className="w-16 lg:w-20 hidden dark:block"
                src="/assets/logos/studypro-shape-white.svg"
                alt="Light mode logo"
              />
            </Link>
          </Button>
        ) : (
          <Button variant="link" asChild>
            <Link to="/">
              <img
                className="w-28 lg:w-32 block dark:hidden"
                src="/assets/logos/studypro-ceo-black.svg"
                alt="Light mode logo"
              />
              <img
                className="w-28 lg:w-32 hidden dark:block"
                src="/assets/logos/studypro-ceo-white.svg"
                alt="Light mode logo"
              />
            </Link>
          </Button>
        )}
        <Menu isOpen={isOpen} setOpenAddBranch={setOpenAddBranchDialog} />
      </div>
    </aside>
  );
}
